import { ActivationCodeController } from './activation-code.controller';

export const ActivationCodeComponent: ng.IComponentOptions = {
    template: require('./activation-code.html'),
    controller: ActivationCodeController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/activation-code/activation-code.component.ts